import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  signal,
  viewChild,
} from '@angular/core';

import { FloatingLabelOutlineComponent } from '@hglobal/common';

let nextControlId = 0;

@Component({
  selector: 'pu-finance-question-editor',
  imports: [FloatingLabelOutlineComponent],
  templateUrl: './finance-question-editor.component.html',
  styleUrl: './finance-question-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinanceQuestionEditorComponent {
  readonly label = input('');
  readonly initialHtml = input('');
  readonly readOnly = input(false);

  readonly host = viewChild<ElementRef<HTMLDivElement>>('host');
  readonly isFocused = signal(false);
  readonly controlId = `finance-question-editor-${nextControlId++}`;

  constructor() {
    effect(() => {
      const element = this.host()?.nativeElement;

      if (!element) {
        return;
      }

      const html = this.initialHtml();

      if (this.readOnly()) {
        if (element.textContent !== html) {
          element.textContent = html;
        }
        return;
      }

      if (element.innerHTML !== html) {
        element.innerHTML = html;
      }
    });
  }

  getHtml(): string {
    return this.readOnly() ? '' : this.host()?.nativeElement.innerHTML ?? '';
  }
}
